import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getConsumerBidderArchive,
  getGeneratorCreatorArchive,
} from "../../Services/ReverseAuction/GetApi";

export const consumerBidderArchiveGet = createAsyncThunk(
  "tokenAccessArchive/consumerBidderArchiveGet",
  async ({ status, page = 0, size = 10, auctionType }) => {
    try {
      let data = await getConsumerBidderArchive({ status, page, size, auctionType });
      return { user: data };
    } catch (err) {
      console.error("Thunk consumerBidderArchiveGet - Error:", err);
    }
  },
);

export const generatorCreatorArchiveGet = createAsyncThunk(
  "tokenAccessArchive/generatorCreatorArchiveGet",
  async ({ status, page = 0, size = 10, auctionType }) => {
    try {
      let data = await getGeneratorCreatorArchive({ status, page, size, auctionType });
      return { user: data };
    } catch (err) {
      console.error("Thunk generatorCreatorArchiveGet - Error:", err);
    }
  },
);

const tokenAccessArchiveSlice = createSlice({
  name: "tokenAccessArchive",
  initialState: {
    consumerBidderArchive: null,
    consumerBidderArchiveTotalPages: 0,
    consumerBidderArchiveCurrentPage: 0,
    generatorCreatorArchive: null,
    generatorCreatorArchiveTotalPages: 0,
    generatorCreatorArchiveCurrentPage: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearConsumerBidderArchive: (state) => {
      state.consumerBidderArchive = null;
    },
    clearGeneratorCreatorArchive: (state) => {
      state.generatorCreatorArchive = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(consumerBidderArchiveGet.pending, (state, action) => {
        state.loading = true;
        if (!action.meta.arg.silent && !action.meta.arg.page) {
          state.consumerBidderArchive = null;
        }
      })
      .addCase(consumerBidderArchiveGet.fulfilled, (state, action) => {
        state.loading = false;
        const innerData = action.payload?.user?.data?.data;
        const alternativeData = action.payload?.user?.data;
        const data = innerData || alternativeData;
        const newPageData = Array.isArray(data?.page)
          ? data.page
          : Array.isArray(data)
            ? data
            : [];

        state.consumerBidderArchive =
          action.meta.arg.page > 0
            ? [...(state.consumerBidderArchive || []), ...newPageData]
            : newPageData;

        const providedTotalPages = data?.totalPages;
        const calculatedTotalPages = Math.ceil(
          (data?.totalElements || 0) / (data?.size || 10),
        );
        state.consumerBidderArchiveTotalPages =
          providedTotalPages ?? calculatedTotalPages;
        state.consumerBidderArchiveCurrentPage = data?.currentPage ?? 0;
      })
      .addCase(consumerBidderArchiveGet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
      });

    builder
      .addCase(generatorCreatorArchiveGet.pending, (state, action) => {
        state.loading = true;
        if (!action.meta.arg.silent && !action.meta.arg.page) {
          state.generatorCreatorArchive = null;
        }
      })
      .addCase(generatorCreatorArchiveGet.fulfilled, (state, action) => {
        state.loading = false;
        const innerData = action.payload?.user?.data?.data;
        const alternativeData = action.payload?.user?.data;
        const data = innerData || alternativeData;
        const newPageData = Array.isArray(data?.page)
          ? data.page
          : Array.isArray(data)
            ? data
            : [];

        state.generatorCreatorArchive =
          action.meta.arg.page > 0
            ? [...(state.generatorCreatorArchive || []), ...newPageData]
            : newPageData;

        const providedTotalPages = data?.totalPages;
        const calculatedTotalPages = Math.ceil(
          (data?.totalElements || 0) / (data?.size || 10),
        );
        state.generatorCreatorArchiveTotalPages =
          providedTotalPages ?? calculatedTotalPages;
        state.generatorCreatorArchiveCurrentPage = data?.currentPage ?? 0;
      })
      .addCase(generatorCreatorArchiveGet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
      });
  },
});

export const { clearConsumerBidderArchive, clearGeneratorCreatorArchive } =
  tokenAccessArchiveSlice.actions;
export default tokenAccessArchiveSlice.reducer;
